import { RestfulClient, Session } from '@benzinga/session';
import { SafePromise } from '@benzinga/safe-await';
import { TtlFifoCache } from '@benzinga/utils';
import { AuthorId } from '../entities/article';
import { IncomingAuthorResult } from '../ingest';
import { ArticleEnvironment } from '../environment';

const AUTHOR_BY_ID_CACHE_TTL_MS = 0.5 * 60 * 60 * 1000;
const authorByIdCache = new TtlFifoCache(2000);

export class AuthorRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(ArticleEnvironment).editorialToolsUrl, session, { 'x-device-key': true });
  }

  getAuthor = async (authorId: AuthorId): SafePromise<IncomingAuthorResult> => {
    const cacheKey = String(authorId);
    const cached = authorByIdCache.get<IncomingAuthorResult>(cacheKey);
    if (cached !== undefined) {
      return Promise.resolve({ ok: cached }) as SafePromise<IncomingAuthorResult>;
    }
    const url = this.URL(`api/v2/author/${authorId}`);
    const result = await this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
    if (result.ok) {
      authorByIdCache.set(cacheKey, result.ok, AUTHOR_BY_ID_CACHE_TTL_MS);
    }
    return result as unknown as SafePromise<IncomingAuthorResult>;
  };

  getAuthorByPath = (path: string): SafePromise<IncomingAuthorResult> => {
    const url = this.URL(`api/v2/author/slug/${path}`);
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };
}
